import { SearchOperators } from '../../enums'
import type { SearchOperatorConfig } from '../../types'

export const frontOperatorValuesToAql = ({ operator, lowValue, highValue }: SearchOperatorConfig): string => {
    if (!lowValue) {
        return ''
    }

    if (operator === SearchOperators.EQUAL_TO) {
        return lowValue
    }

    if (operator === SearchOperators.GREATER_THAN) {
        return `>${lowValue}`
    }

    if (operator === SearchOperators.LESS_THAN) {
        return `<${lowValue}`
    }

    if (operator === SearchOperators.NOT_EQUAL_TO) {
        return `<>${lowValue}`
    }

    if (operator === SearchOperators.BETWEEN && highValue) {
        return `${lowValue}-${highValue}`
    }

    return ''
}

export const backOperatorValuesToAql = ({ operator, lowValue, highValue }: SearchOperatorConfig): string => {
    if (!lowValue) {
        return ''
    }

    if (operator === SearchOperators.EQUAL_TO) {
        return lowValue
    }

    if (operator === SearchOperators.GREATER_THAN) {
        return `${lowValue}+`
    }

    if (operator === SearchOperators.LESS_THAN) {
        return `${lowValue}-`
    }

    if (operator === SearchOperators.NOT_EQUAL_TO) {
        return ''
    }

    if (operator === SearchOperators.BETWEEN && highValue) {
        return `${lowValue}-${highValue}`
    }

    return ''
}

export const operatorConfigToAql = (
    { operator, lowValue, highValue }: SearchOperatorConfig,
    direction: 'front' | 'back',
): string => {
    if (direction === 'front') {
        return frontOperatorValuesToAql({ operator, lowValue, highValue })
    }

    if (direction === 'back') {
        return backOperatorValuesToAql({ operator, lowValue, highValue })
    }

    return ''
}
